import { morph } from '@theme/morph';
import { DialogComponent } from '@theme/dialog';

const SECTION_ID = 'product-info-modal';

/**
 * @param {string} productPageUrl
 * @returns {Promise<Element | null>}
 */
async function fetchProductInfoSection(productPageUrl) {
  if (!productPageUrl) return null;

  const url = new URL(productPageUrl, window.location.origin);
  url.searchParams.set('section_id', SECTION_ID);

  const response = await fetch(url.toString());
  if (!response.ok) {
    throw new Error(`Failed to fetch product info: HTTP ${response.status}`);
  }

  const html = new DOMParser().parseFromString(await response.text(), 'text/html');
  return html.querySelector('[data-product-info-modal-content]');
}

class ProductInfoDialog extends DialogComponent {
  #abortController = null;

  /**
   * @param {string} productPageUrl
   */
  async showProductInfo(productPageUrl) {
    const modalContent = document.getElementById('product-info-modal-content');
    if (!modalContent) return;

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    try {
      const sectionContent = await fetchProductInfoSection(productPageUrl);
      if (!sectionContent) return;

      morph(modalContent, sectionContent);
      this.showDialog();
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.error('Product info modal:', error);
      }
    } finally {
      this.#abortController = null;
    }
  }
}

if (!customElements.get('product-info-dialog')) {
  customElements.define('product-info-dialog', ProductInfoDialog);
}

/**
 * Opens the cart upsell product info modal.
 * @param {string} productPageUrl
 */
export function openProductInfoModal(productPageUrl) {
  const dialog = document.getElementById('product-info-dialog');
  if (dialog instanceof ProductInfoDialog) {
    dialog.showProductInfo(productPageUrl);
  }
}
